import { PageEnum, TABLEPAI, LIFT_FAULT_TABLE_HEADER } from "@/enums/pageEnum";
import { useTranslation } from "react-i18next";
import { getLiftNumberNA } from "@/utils/toolt";
import { Badge, Popover, Space } from "antd";
import { HView, SvgIcon, Status, ParentPonent } from "@/components";
import { GetAlarmStatus, LiftTcPfxBlkNumber } from "@/utils/commonConfig";

const NONBREAKDOWN = "NON_BREAKDOWN";
const BREAKDOWN = "BREAKDOWN";
const URGENT = "URGENT";

export default function LiftFault() {
  const { t } = useTranslation();

  const getBadge = (str: string) => {
    switch (str) {
      case BREAKDOWN:
        return <Badge className="nonBadge" color="#FC0" />;
      case URGENT:
        return <Badge className="nonBadge" color="#F00" />;
      default:
        return <Badge className="nonBadge" color="#ffffff00" />;
    }
  };

  const getColor = (str: string) => {
    switch (str) {
      case BREAKDOWN:
        return "text-[#FC0]";
      case URGENT:
        return "text-[#F00]";
      default:
        return "text-[#000] dark:text-[#fff]";
    }
  };

  const optionRender = (value: string, label: string) => {
    return (
      <Space>
        {(value === BREAKDOWN || value === URGENT) && (
          <span role="img" aria-label={label}>
            {getBadge(value)}
          </span>
        )}
        <span className={getColor(value)}>{label}</span>
      </Space>
    );
  };

  return (
    <ParentPonent
      filterTableFields={[
        { ...LiftTcPfxBlkNumber(t) },
        {
          field: "alarmStatus",
          label: t("alarmStatus"),
          component: "select",
          fieldProps: { style: { width: 180 } },
          options: ["SET", "CLEAR"],
        },
        {
          field: "faultNumber",
          label: t("liftFaultNumber"),
          component: "text",
        },
        {
          field: "severity",
          label: t("severity"),
          component: "select",
          fieldProps: {
            defaultValue: 0,
            style: { width: 150 },
            labelRender: (props: { value: string; label: string }) =>
              optionRender(props.value, props.label),
            optionRender: (option: { value: string; label: string }) =>
              optionRender(option.value, option.label),
          },
          options: [
            { value: 0, label: t("all") },
            { value: NONBREAKDOWN, label: t("Non-breakdown") },
            { value: BREAKDOWN, label: t("breakdown") },
            { value: URGENT, label: t("Urgent") },
          ],
        },
        { field: "lmdClientId", label: t("lMDID"), component: "text" },
        { field: "postalCode", label: t("postalCode"), component: "text" },
        { field: "date", label: t("setTime"), component: "timeRange" },
      ]}
      tableColsRender={[
        {
          dataIndex: "liftName",
          renderText: (_: string, record: { liftId: string }) => (
            <HView
              name={_}
              path={`${PageEnum.LIFT}/detail/${record?.liftId}`}
              isNewWindow
            />
          ),
        },
        {
          dataIndex: "lmdClientId",
          renderText: (_: string, record: { lmdId: string }) => (
            <HView
              name={_}
              path={`${PageEnum.LMD}/detail/${record?.lmdId}`}
              isNewWindow
            />
          ),
        },
        {
          dataIndex: "alarmLiftFaultNumber",
          renderText: (_: number, record: { description: string }) =>
            record?.description ? (
              <Popover content={<p>{record?.description}</p>} title="">
                {_}
              </Popover>
            ) : (
              _
            ),
        },
        {
          dataIndex: "operationalStatusFormat",
          renderText: (_: string) => <Status status={_} />,
        },
        {
          title: (
            <p className="flex justify-center items-center">
              <SvgIcon classa="worng" style={{ width: 20, height: 20 }} />
            </p>
          ),
          align: "center",
          dataIndex: "severity",
          renderText: (_: string) => (
            <Popover content={<p className={getColor(_)}>{t(_)}</p>} title="">
              <div>{getBadge(_)}</div>
            </Popover>
          ),
        },
        GetAlarmStatus(t),
        { dataIndex: "alarmClearTs", render: getLiftNumberNA },
        { dataIndex: "alarmStartTs", render: getLiftNumberNA },
        {
          title: t("action"),
          dataIndex: "action",
          renderText: (_: string, record: { id: string }) => {
            const query = window.location.href.split("?")[1];
            return (
              <HView
                name={t("view")}
                path={`${PageEnum.ALARMLF}/detail/${record?.id}${
                  query ? `?${query}` : ""
                }`}
                state={{ callUrl: `${PageEnum.ALARMLF}${query ? `?${query}` : ""}` }}
              />
            );
          },
        },
      ]}
      countUrl="/api/lift/fault/count"
      tableName="lift/fault"
      editTableHeaderUrl={LIFT_FAULT_TABLE_HEADER}
      requestUrl={TABLEPAI.LIFT_FAULT}
      prantPath={PageEnum.ALARMLF}
      tableTitle={t("liftFaults")}
    />
  );
}
